import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import { injectConfig, configShape } from '@client/hoc/config';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import { setCookie, getCookie } from '@client/helpers/cookie';
import { SEC_SUB_CLOSED_COOKIE, SEC_SUB_SUCCESS_PLACEMENT } from '@client/config/constants';
import {
    getHasOrders,
    getIsSubscribedToNewsletter,
    getHasEmailConfirmed,
    getEmailProvider,
    getNewsletterSubscriptionPending,
    getNewsletterErrorCount,
    getNewsletterError,
} from '../../../../redux/modules/customer/selectors';
import {
    subscribeToNewsletter,
    updateNewsletterError
} from '../../../../redux/modules/customer/actions';

import { track } from '../../../../helpers';

import SecondarySubscriptionMessage from '../SecondarySubscriptionMessage';
import styles from './styles.scss';

export class SecondarySubscription extends PureComponent {
    static propTypes = {
        placement: PropTypes.string,
        isSubscribed: PropTypes.bool.isRequired,
        hasEmailConfirmed: PropTypes.bool.isRequired,
        hasOrders: PropTypes.bool.isRequired,
        emailProvider: PropTypes.string,
        pending: PropTypes.bool.isRequired,
        errorCount: PropTypes.number.isRequired,
        error: PropTypes.bool,
        config: configShape
    }

    state = {
        rejected: false,
        accepted: false,
        expired: false,
        hidden: false,
        closed: getCookie(SEC_SUB_CLOSED_COOKIE),
        isDoi: this.props.config.isEnabled('doi'),
    };

    render() {
        const {
            hasOrders,
            pending,
            error,
            errorCount,
            emailProvider,
            placement
        } = this.props;

        const {
            isDoi,
            rejected,
            accepted,
            hidden
        } = this.state;

        return (this.isVisible &&
            <div
                ref={this.wrapperEl}
                styleName={classNames('wrapper', { hidden, 'success-placement': placement === SEC_SUB_SUCCESS_PLACEMENT })}
            >
                <TranslationsScope path="myLounge.secondarySubscription">
                    <SecondarySubscriptionMessage
                        subscribe={this.subscribeToNewsletter}
                        reject={this.reject}
                        close={this.close}
                        confirmEmail={emailProvider ? this.confirmEmail : null}
                        rejected={rejected}
                        accepted={accepted}
                        error={Boolean(error)}
                        pending={pending}
                        hasOrders={hasOrders}
                        isCucaHelpShown={errorCount > 1}
                        isDoi={isDoi}
                        placement={placement}
                    />
                </TranslationsScope>
            </div>
        );
    }

    componentWillUnmount() {
        this.props.updateNewsletterError(false);
    }

    subscribeToNewsletter = () => {
        this.trackSubscriptionSuccess();

        this.setState({ accepted: true });
        this.props.subscribe();
    }

    reject = () => {
        track('secondary_subscription_no_click');
        this.setState({ rejected: true });
    }

    close = () => {
        track('secondary_subscription_close_click');
        this.hideContainer(500);
        this.setSubscriptionCookie();
    }

    setSubscriptionCookie = () => {
        const expirationTime = new Date(Date.now() + (1000 * 60 * 60 * 24 * 30)); // TODO: move this to setCookie fn
        setCookie(SEC_SUB_CLOSED_COOKIE, true, expirationTime.toUTCString()); // move this to setCookie fn
    }

    hideContainer = (wait) => {
        setTimeout(() => this.setState({ hidden: true }), wait - 500);

        return setTimeout(() => this.setState({ closed: true }), wait);
    }

    confirmEmail = () => {
        window.open(`http://www.${this.props.emailProvider}`, '_blank');
        track('secondary_subscription_inbox_click');
    }

    trackSubscriptionSuccess() {
        const { rejected } = this.state;
        const { error } = this.props;

        const suffix = rejected ? '2' : '1';
        const errorSuffix = 'error';
        track(`secondary_subscription_yes_${error ? errorSuffix : suffix}_click`);
    }

    get isExpired() {
        const { accepted, closed } = this.state;
        const { error, pending } = this.props;

        if (accepted && !error && !pending && !this.timer) {
            const wait = 20 * 1000;
            this.timer = this.hideContainer(wait);
        }

        return closed;
    }

    get isVisible() {
        const { isSubscribed, hasEmailConfirmed } = this.props;
        const { isDoi, closed } = this.state;

        const incomplete = isDoi ? (!isSubscribed || hasEmailConfirmed === false) : !isSubscribed;

        return incomplete && !this.isExpired && !closed;
    }
}

const mapStateToProps = (state) => ({
    isSubscribed: getIsSubscribedToNewsletter(state),
    hasEmailConfirmed: getHasEmailConfirmed(state),
    hasOrders: getHasOrders(state),
    emailProvider: getEmailProvider(state),
    pending: getNewsletterSubscriptionPending(state),
    errorCount: getNewsletterErrorCount(state),
    error: getNewsletterError(state),
});

const mapDispatchToProps = {
    subscribe: subscribeToNewsletter,
    updateNewsletterError
};

export const injectStyles = component => CSSModules(component, styles, { allowMultiple: true });

export default compose(
    injectConfig,
    connect(mapStateToProps, mapDispatchToProps),
    injectStyles
)(SecondarySubscription);
